export class FullUserEntity {
  utronUser;
  userIdentity;
  isMobileUser;
  isDashboardUser;

  constructor(utronUser, userIdentity,isMobileUser) {
    this.utronUser = utronUser;
    this.userIdentity = userIdentity;
    this.isMobileUser = isMobileUser;
    this.isDashboardUser = false;
  }
}
